import React from 'react';
import Icon from 'icon';
import s from './ellipses.module.scss';

export default function SharedEllipses({
  ellipses,
  goto,
  page,
  prefix, ...props }) {
return (
  <div className={`${s.ellipses} ${ellipses ? s.ready : ''}`}>
    {ellipses && (
    <button
      onClick={() => goto(`/${prefix ? `${prefix}/` : ''}${page !== 2 ? page - 1 : ''}`)}
      type="button"
      className={`${s.ellipse} ${s.ellipseNav} ${s.beginning} ${
        page !== 1 ? s.activeNav : s.disable
          }`}
    >
      <span className={s.icon}>
        <Icon icon="chevron-left" />
      </span>
    </button>
      )}
    {ellipses &&
        ellipses.map((ellipse, idx) => {
          const active = page === idx + 1;
          const isLast = ellipses.length - 1 === idx;
          return (
            // eslint-disable-next-line react/no-array-index-key
            <button
              key={idx}
              type="button"
              onClick={() => goto(`/${prefix ? `${prefix}/` : ''}${idx !== 0 ? idx + 1 : ''}`)}
              className={`${s.ellipse} ${active ? s.active : ''} ${
                isLast ? s.last : ''
              }`}
            >
              {idx + 1}
            </button>
          );
        })}
    {ellipses && (
    <button
      type="button"
      onClick={() => goto(`/${prefix ? `${prefix}/` : ''}${page + 1}`)}
      className={`${s.ellipse} ${s.ellipseNav} ${s.end} ${
        page !== ellipses.length ? s.activeNav : s.disable
          }`}
    >
      <span className={s.icon}>
        <Icon icon="chevron-right" />
      </span>
    </button>
      )}
  </div>
);
}
